var map = {
	"./404.svg": 63983,
	"./Ambience.svg": 43433,
	"./Beverage_Quality.svg": 2168,
	"./BrandOverview.svg": 10377,
	"./Cleanliness.svg": 54804,
	"./Competition.svg": 3178,
	"./Competitors.svg": 67790,
	"./FAQ.svg": 49079,
	"./Food_Quality.svg": 3315,
	"./OpenTable.svg": 30863,
	"./Restaurant.svg": 81792,
	"./Service_Quality.svg": 79900,
	"./agoda.svg": 27917,
	"./arrow-up.svg": 67682,
	"./back.svg": 61448,
	"./bed.svg": 53138,
	"./black_ambience.svg": 19877,
	"./black_ambience_circle.svg": 22908,
	"./black_atmosphere.svg": 50637,
	"./black_beverage_quality.svg": 89580,
	"./black_beverage_quality_circle.svg": 85831,
	"./black_breakfast.svg": 75028,
	"./black_checkin.svg": 61842,
	"./black_checkout.svg": 28581,
	"./black_cleanliness.svg": 60776,
	"./black_cleanliness2.svg": 72618,
	"./black_cleanliness_circle.svg": 82707,
	"./black_food.svg": 46097,
	"./black_food_quality.svg": 85759,
	"./black_food_quality_circle.svg": 39666,
	"./black_location.svg": 35724,
	"./black_room.svg": 87788,
	"./black_service.svg": 85322,
	"./black_service_quality.svg": 77944,
	"./black_service_quality_circle.svg": 48707,
	"./black_value.svg": 23272,
	"./black_value_perception.svg": 41702,
	"./black_value_perception_circle.svg": 36773,
	"./booking.svg": 1522,
	"./bug.svg": 32337,
	"./build.svg": 24895,
	"./button.svg": 36205,
	"./cascader.svg": 13629,
	"./category-icons.svg": 27548,
	"./chart.svg": 6707,
	"./checkbox.svg": 52202,
	"./clean.svg": 83316,
	"./clipboard.svg": 55013,
	"./close.svg": 88655,
	"./code.svg": 75130,
	"./color.svg": 61018,
	"./com.svg": 27060,
	"./component.svg": 58662,
	"./copy.svg": 51706,
	"./crm.svg": 2775,
	"./dashboard.svg": 86707,
	"./date-range.svg": 17325,
	"./date.svg": 96169,
	"./dict.svg": 42957,
	"./documentation.svg": 34473,
	"./download.svg": 85081,
	"./drag.svg": 93975,
	"./druid.svg": 32195,
	"./edit.svg": 47713,
	"./education.svg": 63653,
	"./email.svg": 73751,
	"./error-triangle.svg": 75522,
	"./example.svg": 20613,
	"./excel.svg": 50134,
	"./exit-fullscreen.svg": 85441,
	"./expedia.svg": 47211,
	"./eye-open.svg": 69529,
	"./eye.svg": 26240,
	"./feed.svg": 53913,
	"./filter.svg": 21955,
	"./food.svg": 90965,
	"./form.svg": 44527,
	"./fresh.svg": 70675,
	"./fresh1.svg": 26456,
	"./fullscreen.svg": 3090,
	"./github.svg": 70140,
	"./go.svg": 7119,
	"./google.svg": 41408,
	"./guide.svg": 50471,
	"./half-year-review.svg": 7169,
	"./hotel.svg": 48645,
	"./hotelde.svg": 91716,
	"./icon.svg": 85242,
	"./icon_Ambience.svg": 82205,
	"./icon_Beverage_Quality.svg": 15284,
	"./icon_Cleanliness.svg": 76624,
	"./icon_Food_Quality.svg": 39719,
	"./icon_Service_Quality.svg": 90560,
	"./icon_Value_For_Money.svg": 54861,
	"./ihg.svg": 8873,
	"./info-circle.svg": 47318,
	"./input.svg": 6743,
	"./inside.svg": 78829,
	"./internal.svg": 82274,
	"./international.svg": 9559,
	"./job.svg": 89970,
	"./language.svg": 89419,
	"./legend_dot.svg": 78042,
	"./legend_line.svg": 54979,
	"./link.svg": 22273,
	"./list.svg": 71026,
	"./location.svg": 6824,
	"./lock.svg": 83368,
	"./log.svg": 717,
	"./logOut.svg": 19563,
	"./logininfor.svg": 56570,
	"./luxuryescapes.svg": 71554,
	"./magic.svg": 56662,
	"./makemytrip.svg": 50740,
	"./market-overview.svg": 27323,
	"./market-signals.svg": 54513,
	"./marriott.svg": 28203,
	"./message.svg": 31498,
	"./mobile.svg": 65595,
	"./money.svg": 57039,
	"./monitor.svg": 41613,
	"./more.svg": 63766,
	"./morefilter.svg": 66036,
	"./needs-attention.svg": 73049,
	"./nested.svg": 98236,
	"./number.svg": 12330,
	"./ok.svg": 97739,
	"./online.svg": 93160,
	"./password.svg": 83650,
	"./pdf.svg": 63365,
	"./people.svg": 47908,
	"./peoples.svg": 26895,
	"./phone.svg": 33351,
	"./pieChart.svg": 97391,
	"./post.svg": 28955,
	"./qq.svg": 1195,
	"./quality-standards.svg": 35721,
	"./question.svg": 94793,
	"./radio.svg": 56374,
	"./rate.svg": 57487,
	"./redis-list.svg": 19995,
	"./redis.svg": 47910,
	"./refresh.svg": 2606,
	"./reply-library.svg": 69669,
	"./reply-setting.svg": 23288,
	"./reply.svg": 15299,
	"./report.svg": 56907,
	"./reports.svg": 46722,
	"./reviewHover.svg": 49237,
	"./reviews.svg": 6828,
	"./row.svg": 9015,
	"./search.svg": 22701,
	"./select.svg": 71885,
	"./server.svg": 7076,
	"./service.svg": 46798,
	"./services.svg": 40785,
	"./set.svg": 24751,
	"./shopping.svg": 805,
	"./size.svg": 68418,
	"./skill.svg": 9092,
	"./slider.svg": 72322,
	"./social.svg": 52168,
	"./star.svg": 77841,
	"./sun.svg": 9941,
	"./survey-detail.svg": 53859,
	"./survey-during-stay.svg": 14947,
	"./survey-post-stay.svg": 78248,
	"./survey.svg": 303,
	"./swagger.svg": 92019,
	"./switch.svg": 80381,
	"./system.svg": 23626,
	"./tab.svg": 23202,
	"./table.svg": 40987,
	"./text.svg": 44664,
	"./textarea.svg": 51083,
	"./theme.svg": 28832,
	"./time-range.svg": 76402,
	"./time.svg": 61146,
	"./tool.svg": 72387,
	"./tooltip.svg": 41674,
	"./trans.svg": 56193,
	"./translation.svg": 15394,
	"./tree-table.svg": 10794,
	"./tree.svg": 33585,
	"./trip.svg": 59984,
	"./tripadvisor.svg": 70400,
	"./upload.svg": 28174,
	"./user.svg": 23900,
	"./validCode.svg": 74302,
	"./wechat.svg": 27331,
	"./where.svg": 64978,
	"./wongnai.svg": 67486,
	"./yelp.svg": 71579,
	"./zip.svg": 44002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;